import { render } from "./BatchesWaitingBalanceTableContainer.vue?vue&type=template&id=74d0a595"
import script from "./BatchesWaitingBalanceTableContainer.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingBalanceTableContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__